import React from 'react';
import './WaiverStatus.css';

function SignedWaiversDisplay({ user }) {
  // Check if user has signed waivers
  const hasSignedWaivers = user?.familyGuidelinesSigned && user?.waiverSigned;
  
  // Don't render anything if no waivers are signed
  if (!hasSignedWaivers) {
    return null;
  }

  return (
    <div className="waiver-status-section">
      <div className="waiver-status-title">
        📋 Signed Documents
      </div>
      
      <div className="waiver-items">
        {user.familyGuidelinesSigned && (
          <div className="waiver-item">
            <div className="waiver-name">
              ✅ Family Guidelines
            </div>
            <div className="waiver-date">
              Signed: {user.familyGuidelinesSignedDate}
            </div>
          </div>
        )}
        
        {user.waiverSigned && (
          <div className="waiver-item">
            <div className="waiver-name">
              ✅ Liability Waiver
            </div>
            <div className="waiver-date">
              Signed: {user.waiverSignedDate}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SignedWaiversDisplay;
